import React, { useState } from 'react';
import { CreateCommentRequest } from '../../types/grammarPractice';

interface AddCommentFormProps {
  onSubmit: (request: CreateCommentRequest) => Promise<any>;
  onCancel?: () => void;
  placeholder?: string;
  submitButtonText?: string;
}

const AddCommentForm: React.FC<AddCommentFormProps> = ({
  onSubmit,
  onCancel,
  placeholder = 'Write a comment...',
  submitButtonText = 'Post Comment',
}) => {
  const [content, setContent] = useState('');
  const [isIssueReport, setIsIssueReport] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!content.trim()) {
      setError('Comment cannot be empty');
      return;
    }

    try {
      setSubmitting(true);
      setError(null);

      await onSubmit({
        content,
        is_issue_report: isIssueReport,
      });

      // Reset form
      setContent('');
      setIsIssueReport(false);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to post comment');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <textarea
        className="textarea textarea-bordered w-full"
        rows={3}
        placeholder={placeholder}
        value={content}
        onChange={(e) => setContent(e.target.value)}
        disabled={submitting}
      />

      {error && (
        <div className="alert alert-error">
          <span>{error}</span>
        </div>
      )}

      <div className="flex items-center justify-between">
        <label className="label cursor-pointer gap-2">
          <input
            type="checkbox"
            className="checkbox checkbox-sm"
            checked={isIssueReport}
            onChange={(e) => setIsIssueReport(e.target.checked)}
            disabled={submitting}
          />
          <span className="label-text">Report an issue with this exercise</span>
        </label>

        <div className="flex gap-2">
          {onCancel && (
            <button
              type="button"
              className="btn btn-sm btn-ghost"
              onClick={onCancel}
              disabled={submitting}
            >
              Cancel
            </button>
          )}
          <button
            type="submit"
            className="btn btn-sm btn-primary"
            disabled={submitting || !content.trim()}
          >
            {submitting ? 'Posting...' : submitButtonText}
          </button>
        </div>
      </div>
    </form>
  );
};

export default AddCommentForm;
